import { useFormik } from "formik";
import moment from "moment";
import { useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import CustomTable from "../../../Shared/CustomTable";
import CustomToPagination from "../../../Shared/Pagination";
import { apiConnectorGet, apiConnectorPost } from "../../../utils/APIConnector";
import { endpoint } from "../../../utils/APIRoutes";
import { formatedDate, getFloatingValue } from "../../../utils/utilityFun";
import CustomTableSearch from "../../Shared/CustomTableSearch";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
const MemberList = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [revealedPassIndex, setRevealedPassIndex] = useState(null);
  const client = useQueryClient();
  const initialValues = {
    search: "",
    count: 10,
    start_date: "",
    end_date: "",
  };

  const fk = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
  });
  const { data, isLoading } = useQuery(
    [
      "get_member_list",
      fk.values.search,
      fk.values.start_date,
      fk.values.end_date,
      page,
    ],
    () =>
      apiConnectorPost(endpoint?.member_list, {
        search: fk.values.search,
        created_at: fk.values.start_date,
        updated_at: fk.values.end_date,
        page: page,
        count: fk.values.count,
      }),
    {
      keepPreviousData: true,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      onError: (err) => console.error("Error fetching direct data:", err),
    },
  );

  const allData = data?.data?.result || [];

  async function showBusiness(userId) {
    setLoading(true);
    try {
      const { data } = await apiConnectorGet(
        endpoint?.user_dashboard_business_api,
        { userId: userId },
      );
      const directBusines = getFloatingValue(data?.result?.direct_business);
      const TeamBusines = getFloatingValue(data?.result?.team_business);
      Swal.fire({
        title:
          '<span style="color:#22d3ee;font-weight:700;font-size:1.2rem;">Total Business</span>',
        html: `
          <div style="display:flex;gap:1.5rem;justify-content:center;align-items:center;margin-top:1rem;">
            <div style="background:linear-gradient(135deg,#0a192f 60%,#22d3ee 100%);border-radius:1rem;padding:1.2rem 2.2rem;box-shadow:0 4px 24px #22d3ee33;display:flex;flex-direction:column;align-items:center;">
              <div style="font-size:0.9rem;color:#bae6fd;letter-spacing:1px;font-weight:600;">Direct Business</div>
              <div style="font-size:1.3rem;color:#22d3ee;font-weight:700;margin-top:0.2rem;">$${directBusines}</div>
            </div>
            <div style="background:linear-gradient(135deg,#0a192f 60%,#38bdf8 100%);border-radius:1rem;padding:1.2rem 2.2rem;box-shadow:0 4px 24px #38bdf833;display:flex;flex-direction:column;align-items:center;">
              <div style="font-size:0.9rem;color:#bae6fd;letter-spacing:1px;font-weight:600;">Team Business</div>
              <div style="font-size:1.3rem;color:#38bdf8;font-weight:700;margin-top:0.2rem;">$${TeamBusines}</div>
            </div>
          </div>
        `,
        background: "#101827",
        icon: "info",
        confirmButtonColor: "#22d3ee",
        customClass: {
          popup: "swal2-card-theme",
          title: "swal2-title-theme",
        },
        confirmButtonText: "OK",
      });
    } catch (error) {
      console.error("Error fetching business data:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to fetch business data. Please try again later.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
    setLoading(false);
  }

  const getUserId = (row) => row?.tr03_reg_id || row?.lgn_jnr_id;

  const escapeHtml = (value) =>
    String(value ?? "N/A")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  const updateMemberProfile = async (reqBody, successTitle = "Updated") => {
    setLoading(true);
    try {
      const res = await apiConnectorPost(endpoint?.update_profile, reqBody);
      const isSuccess = Boolean(res?.data?.success);

      await Swal.fire({
        title: isSuccess ? successTitle : "Error!",
        text:
          res?.data?.message ||
          (isSuccess ? "Updated successfully." : "Failed to update."),
        icon: isSuccess ? "success" : "error",
        confirmButtonColor: "black",
      });

      if (isSuccess) {
        client.invalidateQueries(["get_member_list"]);
      }
    } catch (e) {
      await Swal.fire({
        title: "Error!",
        text: e?.response?.data?.message || "Failed to update profile.",
        icon: "error",
        confirmButtonColor: "black",
      });
    }
    setLoading(false);
  };

  const openSingleFieldPopup = async ({
    title,
    inputValue = "",
    fieldKey,
    row,
    confirmButtonText = "Submit",
  }) => {
    const userId = getUserId(row);
    const custIdValue =
      row?.tr03_cust_id || row?.lgn_cust_id || row?.customer_id;
    const pammIdValue = row?.tr03_mt_trd_id || row?.mt5_id;
    if (!userId) {
      Swal.fire({
        title: "Error!",
        text: "User id not found.",
        icon: "error",
        confirmButtonColor: "black",
      });
      return;
    }

    const result = await Swal.fire({
      title,
      input: "text",
      html: `
        <div style="text-align:left; font-size:13px; margin:6px 0 8px;">
          <div><strong>Cust ID:</strong> ${escapeHtml(custIdValue)}</div>
          <div style="margin-top:4px;"><strong>PAMM ID:</strong> ${escapeHtml(pammIdValue)}</div>
        </div>
      `,
      inputValue: inputValue || "",
      showCancelButton: true,
      confirmButtonText,
      confirmButtonColor: "black",
      cancelButtonColor: "#6b7280",
      inputValidator: (value) => {
        if (!value || !String(value).trim()) {
          return "This field is required";
        }
        return null;
      },
    });

    if (!result.isConfirmed) {
      return;
    }

    await updateMemberProfile(
      {
        user_id: userId,
        [fieldKey]: String(result.value).trim(),
      },
      "Updated Successfully",
    );
  };

  const openPasswordPopup = async (row) => {
    const userId = getUserId(row);
    if (!userId) {
      Swal.fire({
        title: "Error!",
        text: "User id not found.",
        icon: "error",
        confirmButtonColor: "black",
      });
      return;
    }

    const oldPass = row?.lgn_pass || "";

    const result = await Swal.fire({
      title: "Update Password",
      html: `
        <div style="text-align:left; margin-top:8px;">
          <label style="display:block; margin-bottom:6px; font-size:13px;">Old Password</label>
          <input id="swal-old-pass" class="swal2-input" value="${oldPass}" readonly />
          <label style="display:block; margin:10px 0 6px; font-size:13px;">New Password</label>
          <input id="swal-new-pass" class="swal2-input" placeholder="Enter new password" />
        </div>
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Submit",
      confirmButtonColor: "black",
      cancelButtonColor: "#6b7280",
      preConfirm: () => {
        const newPassValue = document
          .getElementById("swal-new-pass")
          ?.value?.trim();
        const oldPassValue =
          document.getElementById("swal-old-pass")?.value || "";

        if (!newPassValue) {
          Swal.showValidationMessage("New password is required");
          return null;
        }

        return {
          oldPass: oldPassValue,
          newPass: newPassValue,
        };
      },
    });

    if (!result.isConfirmed || !result.value) {
      return;
    }

    await updateMemberProfile(
      {
        user_id: userId,
        oldPass: result.value.oldPass,
        newPass: result.value.newPass,
      },
      "Password Updated",
    );
  };

  const tablehead = [
    <span>S.No.</span>,
    <span>Email</span>,
    <span>Mobile</span>,
    <span>Customer Id</span>,
    <span>Name</span>,
    <span>Password</span>,
    <span>Spon Id</span>,
    <span>Spon Name</span>,
    <span>Topup Wallet</span>,
    <span>Registration Date</span>,
    <span>Total Income</span>,
    <span>Current Balance</span>,
    <span>Fund Wallet</span>,
  ];
  const tablerow = allData?.data?.map((row, index) => {
    return [
      <span> {(page - 1) * (fk.values.count || 10) + index + 1}</span>,
      <span
        className="cursor-pointer text-cyan-400"
        onClick={() =>
          openSingleFieldPopup({
            title: "Enter Email",
            inputValue: row?.lgn_email,
            fieldKey: "email",
            row,
          })
        }
      >
        {row.lgn_email || "N/A"}
      </span>,
      <span
        className="cursor-pointer text-cyan-400"
        onClick={() =>
          openSingleFieldPopup({
            title: "Enter Mobile",
            inputValue: row?.lgn_mobile,
            fieldKey: "mobile",
            row,
          })
        }
      >
        {row.lgn_mobile || "N/A"}
      </span>,
      <span> {row.lgn_cust_id}</span>,
      <span
        className="cursor-pointer text-cyan-400"
        onClick={() =>
          openSingleFieldPopup({
            title: "Enter Name",
            inputValue: row?.lgn_name,
            fieldKey: "name",
            row,
          })
        }
      >
        {row.lgn_name || "N/A"}
      </span>,
      <span
        className="cursor-pointer text-cyan-400 font-mono"
        onClick={() => openPasswordPopup(row)}
      >
        {row.lgn_pass ? "•••••••" : "N/A"}
      </span>,
      <span>{row.spon_id || "N/A"}</span>,
      <span>{row.spon_name || "N/A"}</span>,
      <span> {getFloatingValue(row.tr03_topup_wallet)}</span>,
      <span> {formatedDate(moment, row.tr03_reg_date)}</span>,
      <span> {getFloatingValue(row.tr03_total_income)}</span>,
      <span> {getFloatingValue(row.tr03_inc_wallet)}</span>,
      <span> {getFloatingValue(row.tr03_fund_wallet)}</span>,
    ];
  });

  return (
    <div className="p-2">
      <CustomTableSearch
        fk={fk}
        onClearFn={() => {
          setPage(1);
        }}
        onSubmitFn={() => {
          setPage(1);
          client.invalidateQueries(["get_member_list"]);
        }}
      />

      {/* Table Section */}
      <div
        className="
        rounded-lg py-3
        text-white
        bg-black
        border border-gray-700
        shadow-md shadow-white/20
      "
      >
        <CustomTable
          tablehead={tablehead}
          tablerow={tablerow}
          isLoading={isLoading || loading}
        />

        {/* Total Income */}
        {/* <div className="flex justify-end py-3 text-sm font-semibold text-green-400">
          Total Income : $ {allData?.totalAmount || 0}
        </div> */}

        {/* Pagination */}
        <CustomToPagination page={page} setPage={setPage} data={allData} />
      </div>
    </div>
  );
};

export default MemberList;
